module.exports = __webpack_public_path__ + "static/media/pub_ambience.76d325c0.mp3";